import { DataProvider } from "services/DataProvider";

// fetches and saves circle data from GitHub respositories
export default class GitHubDataProvider extends DataProvider {}
